import { createSelector } from 'selectors'

import { constant } from './constant'

export const getSessionModal = () => createSelector<HTMLElement | null>({ selector: constant.selector.sessionModal })
export const getCountdown = () => createSelector<HTMLElement | null>({ selector: constant.selector.countdown })
